// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"fbfd71ba","364":"d98b55b0","582":"542f28e8","614":"9091b330","828":"f652bea2","982":"53756519"}[chunkId] + ".chunk.js";
};